module.exports = __webpack_public_path__ + "img/gkzy-white.9fdc8c2a.png";